"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var utils_1 = require("./utils");
var query_string_1 = __importDefault(require("query-string"));
var product_1 = __importDefault(require("./components/product"));
var main_filter_1 = __importDefault(require("./components/main-filter"));
var constants_1 = require("./constants");
var header_1 = __importDefault(require("./components/header"));
var App = function (_a) {
    var pageType = _a.pageType;
    var location = react_router_1.useLocation();
    var _b = react_1.useState(), searchParams = _b[0], setSearchParams = _b[1];
    var _c = react_1.useState(), products = _c[0], setProducts = _c[1];
    var _d = react_1.useState(), merchants = _d[0], setMerchants = _d[1];
    var _e = react_1.useState(), merchantCount = _e[0], setMerchantCount = _e[1];
    var _f = react_1.useState(), pageTitle = _f[0], setPageTitle = _f[1];
    var _g = react_1.useState(), page = _g[0], setPage = _g[1];
    var _h = react_1.useState(), brands = _h[0], setBrands = _h[1];
    var _j = react_1.useState(), categories = _j[0], setCategories = _j[1];
    var _k = react_1.useState(), provinces = _k[0], setProvinces = _k[1];
    var _l = react_1.useState(true), isLoading = _l[0], setLoading = _l[1];
    react_1.useEffect(function () {
        console.log("Build 290421");
    }, []);
    react_1.useEffect(function () {
        var _a, _b;
        if (pageType) {
            var urlParams = location.search;
            var parsedUrlParams = query_string_1.default.parse(urlParams);
            var newSearchParam = __assign(__assign({}, searchParams), parsedUrlParams);
            if (pageType !== "shop") {
                try {
                    var urlPathParam = location.pathname
                        .split("/")[
                    //@ts-ignore
                    constants_1.pageTypeMap[pageType].index].split("-")
                        .pop();
                    var urlPathParamArray = [];
                    if (urlPathParam) {
                        urlPathParamArray = urlPathParam.split(",");
                    }
                    var oldParam = void 0;
                    if (newSearchParam.category) {
                        oldParam = newSearchParam.category.split(",");
                    }
                    else {
                        oldParam = [];
                    }
                    var newParam = __spreadArray(__spreadArray([], urlPathParamArray), oldParam);
                    newSearchParam = __assign(__assign({}, newSearchParam), (_a = {}, _a[constants_1.pageTypeMap[pageType].newName] = newParam.join(","), _a));
                }
                catch (e) { }
            }
            if (pageType === "category" && newSearchParam.category) {
                utils_1.fetchCategoryDetails(Number(newSearchParam.category.split(",")[0])).then(function (res) {
                    setPageTitle("Produk Kategori " + res.data.name);
                });
            }
            if (pageType === "store" ||
                pageType === "dekranas" ||
                pageType === "umkm" ||
                pageType === "gkp") {
                utils_1.fetchMarket(pageType).then(function (res) {
                    return setPageTitle(res.data.name);
                });
                //@ts-ignore
                if (!newSearchParam[constants_1.marketTypeMap[pageType].paramName]) {
                    newSearchParam = __assign(__assign({}, newSearchParam), (_b = {}, _b[constants_1.marketTypeMap[pageType].paramName] = constants_1.marketTypeMap[pageType].paramValue, _b));
                }
            }
            setSearchParams(newSearchParam);
        }
    }, [pageType]);
    react_1.useEffect(function () {
        if (searchParams) {
            setLoading(true);
            var urlParameter = query_string_1.default.stringify(searchParams, {
                encode: false,
            });
            window.history.replaceState(null, document.title, location.pathname + "?" + urlParameter);
            utils_1.fetchProducts(searchParams).then(function (res) {
                setProducts(res.data.products);
                setMerchants(res.data.merchants.data);
                setMerchantCount(res.data.merchants.count);
                setPage(res.data.page);
                setLoading(false);
                setBrands(res.data.brands);
                setCategories(res.data.categories);
                setProvinces(res.data.locations);
            });
        }
    }, [searchParams]);
    return (react_1.default.createElement(react_1.Fragment, null,
        pageType === 'gkp' ? (react_1.default.createElement(header_1.default, { searchParams: searchParams, setSearchParams: setSearchParams, isLoading: isLoading })) : null,
        react_1.default.createElement(main_filter_1.default, { searchParams: searchParams, setSearchParams: setSearchParams, isLoading: isLoading, brands: brands, categories: categories, provinces: provinces }),
        react_1.default.createElement(product_1.default, { searchParams: searchParams, setSearchParams: setSearchParams, merchantCount: merchantCount, merchants: merchants, isLoading: isLoading, page: page, products: products, pageTitle: pageTitle })));
};
if (document.getElementById("app")) {
    // find element by id
    var element = document.getElementById("app");
    if (element) {
        // create new props object with element's data-attributes
        // result: {tsId: "1241"}
        var props = Object.assign({}, element.dataset);
        // render element with props (using spread)
        react_dom_1.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(App, { pageType: props.pageType })), element);
    }
}
